import React, { MouseEvent, ElementType } from 'react';

type HtmlContentProps<T extends ElementType> = {
  as?: T;
  children: string;
} & React.ComponentPropsWithoutRef<T>;

export function HtmlContent<T extends ElementType = 'span'>({ as, children, ...props }: HtmlContentProps<T>) {
  const Component = as || ('span' as ElementType);

  const handleClick = (e: MouseEvent<HTMLElement>) => {
    const target = e.target as HTMLElement;
    const anchor = target.closest('a');

    if (anchor) {
      const href = anchor.getAttribute('href');
      if (href && href.startsWith('/')) {
        e.preventDefault();
        window.history.pushState({}, '', href);
      }
    }
  };

  return React.createElement(Component, {
    ...props,
    onClick: handleClick,
    dangerouslySetInnerHTML: { __html: children }
  });
}
